import { useState } from "react";
import { cn } from "../../../../utils/classNames";

const dirButtonClasses = "flex items-center gap-1 w-full text-left py-1 px-2 rounded hover:bg-surface-muted text-sm font-medium text-label";
const fileButtonClasses = "block w-full text-left py-1 px-2 rounded hover:bg-surface-muted text-sm text-body truncate";
const activeFileClasses = "bg-primary-surface text-primary font-medium";
const caretClasses = "inline-block w-3 text-xs text-subtle";

const TreeNode = ({ node, selectedKey, onSelect }) => {
    const [open, setOpen] = useState(true);

    if (node.type === "dir") {
        return (
            <li>
                <button type="button" className={dirButtonClasses} onClick={() => setOpen((prev) => !prev)}>
                    <span className={caretClasses}>{open ? "v" : ">"}</span>
                    {node.name}
                </button>
                {open && (
                    <ul className="list-none m-0 pl-4">
                        {node.children.map((child) => (
                            <TreeNode key={child.key || child.name} node={child} selectedKey={selectedKey} onSelect={onSelect} />
                        ))}
                    </ul>
                )}
            </li>
        );
    }

    return (
        <li>
            <button
                type="button"
                className={cn(fileButtonClasses, selectedKey === node.key && activeFileClasses)}
                onClick={() => onSelect(node)}
            >
                {node.name}
            </button>
        </li>
    );
};

// Recursive collapsible folder/file tree for the design docs sidebar
const DesignSidebarTree = ({ nodes, selectedKey, onSelect }) => (
    <ul className="list-none m-0 p-0">
        {nodes.map((node) => (
            <TreeNode key={node.key || node.name} node={node} selectedKey={selectedKey} onSelect={onSelect} />
        ))}
    </ul>
);

export default DesignSidebarTree;
